export const WIDGET_SLOTS = {
  homeTop: "home_top",
  homeBottom: "home_bottom",
  fboDetailSidebar: "fbo_detail_sidebar",
  fboDetailAboveSections: "fbo_detail_above_sections",
  fboDetailBelowSections: "fbo_detail_below_sections",
  airportDetailInline: "airport_detail_inline",
  flightSchoolDetailInline: "flight_school_detail_inline",
  fbosDirectoryInline: "fbos_directory_inline",
  // Search submissions land on the public FBO directory. Keep their inventory
  // distinct from the browse-directory slot so a search result is not sold as
  // an unrelated directory impression. Creatives use the existing
  // `sponsored_recommendation` (or another WIDGET_STYLES) contract.
  searchResultsInline: "search_results_inline",
  siteFooter: "site_footer",
  // Dedicated single-surface slots. The resolver returns one winner PER slot, so
  // each legacy sponsor surface that historically rendered independently gets its
  // own slot — otherwise they would compete and only one would survive. The
  // generic slots above stay free for new admin-created sponsorships.
  fboDetailFuel: "fbo_detail_fuel",
  fboDetailGoRentals: "fbo_detail_go_rentals",
  fboDetailPartner: "fbo_detail_partner",
  fboDetailLiveAtc: "fbo_detail_live_atc",
  fboDetailNetwork: "fbo_detail_network",
  fboDetailSportys: "fbo_detail_sportys",
  airportDetailSportys: "airport_detail_sportys",
  flightSchoolDetailSportys: "flight_school_detail_sportys",
  // Staged contextual placements. They are inert until an approved placement
  // definition and eligible resolver winner exist.
  maintenanceDetail: "maintenance_detail_inline",
  serviceProviderDetail: "service_provider_detail_inline",
  mapLocationDrawer: "map_location_drawer",
  destinationDetail: "destination_detail_inline",
  educationalResource: "educational_resource_inline",
  planningExperience: "planning_experience_inline",
  displayScreen: "display_screen_sponsor",
  // Reserved for future real aircraft routes only; no aircraft UI is created.
  aircraftDiscovery: "aircraft_discovery_inline",
  aircraftDetail: "aircraft_detail_inline",
} as const;
